import React, { useContext, useEffect, useState } from "react";
import { AppDataContext } from "../context/appData";
import { DarkModeContext } from "../context/darkModeContext";
import SocialLogin from "../components/SocialLogin";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getURLs } from "../urlConfig";
import AccountVerificationPopup from "../components/AccountVerificationPopup";

const InstructorSignup = () => {
  const {
    state: { appData },
  } = useContext(AppDataContext);

  const {
    state: { darkMode },
  } = useContext(DarkModeContext);

  const navigate = useNavigate();

  const [pageData, setPageData] = useState(
    appData?.instructorAuthPagesData?.signupPageData
  );

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [socialLoginError, setSocialLoginError] = useState("");
  const [error, setError] = useState();
  const [signupLoading, setSignupLoading] = useState(false);

  const [accountVerificationPendingModal, setAccountVerificationModal] =
    useState(false);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.password ||
      formData.password?.length < 8
    ) {
      return;
    }

    if (signupLoading) return;
    setSignupLoading(true);
    axios
      .post(getURLs("verify-email"), { email: formData.email })
      .then((res) => {
        if (res.status === 200)
          navigate("/verify-otp", {
            state: {
              ...formData,
              role: ["instructor"],
              isSigningup: true,
            },
          });
      })
      .catch((err) => {
        if (
          err?.response?.status === 400 ||
          err?.response?.status === 401 ||
          err?.response?.status === 500
        )
          setError(err?.response?.data?.message);
        setSignupLoading(false);
        console.log(err);
      });
  };

  const handleCloseAccountVerificationModal = (path) => {
    setAccountVerificationModal(false);
    navigate(`${path}`);
  };

  useEffect(() => {
    setPageData(appData?.instructorAuthPagesData?.signupPageData);
  }, [appData?.instructorAuthPagesData?.signupPageData]);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="px-4 md:px-8 lg:px-14 py-4 md:py-8 lg:py-14 bg-[#e8eef8] md:bg-white dark:bg-darkBgColor1">
        <p className="font-urbanist text-center text-black dark:text-white font-semibold text-lg md:text-xl md:hidden block mb-2">
          {pageData?.heading}
        </p>
        <p className="font-urbanist text-center font-medium text-black dark:text-white text-sm sm:text-base md:hidden block mb-4">
          {pageData?.subHeading}
        </p>

        {/* container */}
        <div className="bg-white dark:bg-purple14 flex flex-col shadow-shadow17 dark:shadow-shadow18 border dark:border-purple14 rounded-xl px-4 md:px-8 lg:px-12 py-4 md:py-8 lg:py-12">
          {/* text */}
          <div className="md:flex flex-col space-y-5 hidden">
            <p className="hidden md:block font-urbanist text-black dark:text-white font-semibold sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
              {pageData?.heading}
            </p>
            <p className="hidden md:block font-urbanist font-medium text-black dark:text-white text-sm sm:text-base">
              {pageData?.subHeading}
            </p>
          </div>

          {/* form and image */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
            {/* img */}
            <div className="hidden md:basis-1/2 w-full md:flex items-center justify-center px-5 py-5">
              <img
                src={
                  darkMode
                    ? pageData?.formDetails?.formImageDark
                    : pageData?.formDetails?.formImageLight
                }
                alt="login_thumbnail"
                className="max-w-[500px] max-h-[300px] w-full h-full object-contain"
              />
            </div>

            {/* form */}
            <div className="basis-1/2 w-full">
              <div className="md:border md:dark:border-purple13 md:shadow-shadow16 md:rounded-md px-5 py-5 md:max-w-sm dark:bg-purple19">
                <h4 className="text-black1 dark:text-white font-urbanist font-bold text-lg md:text-xl lg:text-2xl block mb-2">
                  {pageData?.formDetails?.heading}
                </h4>
                <p className="text-gray14 dark:text-white font-urbanist font-medium text-sm sm:text-base block mb-5">
                  {pageData?.formDetails?.description}
                </p>

                {/* form */}
                <form className="flex flex-col" onSubmit={handleFormSubmit}>
                  <p className="block mb-1 font-urbanist text-sm font-medium text-gray-500 dark:text-white">
                    Name
                  </p>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="Enter your name"
                    value={formData?.name}
                    onChange={handleInputChange}
                    className="flex-grow bg-white dark:bg-purple12 border dark:border-purple12 border-gray-200 rounded-lg w-full px-2 outline-none py-2 text-sm font-urbanist font-normal text-gray-600 dark:text-white mb-4"
                  />

                  <p className="block mb-1 font-urbanist text-sm font-medium text-gray-500 dark:text-white">
                    Email
                  </p>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Enter your email"
                    value={formData?.email}
                    onChange={handleInputChange}
                    className="flex-grow bg-white dark:bg-purple12 border dark:border-purple12 border-gray-200 rounded-lg w-full px-2 outline-none py-2 text-sm font-urbanist font-normal text-gray-600 dark:text-white mb-4"
                  />

                  <p className="block mb-1 font-urbanist text-sm font-medium text-gray-500 dark:text-white">
                    Password
                  </p>
                  <input
                    type="password"
                    name="password"
                    required
                    placeholder="Enter your password"
                    value={formData?.password}
                    onChange={handleInputChange}
                    className="flex-grow bg-white dark:bg-purple12 border dark:border-purple12 border-gray-200 rounded-lg w-full px-2 outline-none py-2 text-sm font-urbanist font-normal text-gray-600 dark:text-white"
                  />
                  <p className="block mb-4 text-xs mt-1 font-urbanist font-normal text-gray-400">
                    Must be atleast 8 characters
                  </p>
                  <button
                    type="submit"
                    className={`bg-background5 disabled:bg-background6 font-urbanist font-medium text-white rounded-md px-4 py-2 text-sm mb-4`}
                    disabled={signupLoading}
                  >
                    {pageData?.formDetails?.buttonText}
                  </button>

                  <SocialLogin
                    role={["instructor"]}
                    setSocialLoginError={setSocialLoginError}
                    setAccountVerificationModal={setAccountVerificationModal}
                  />

                  {error?.length > 0 && (
                    <span className="text-xs sm:text-sm font-urbanist text-red-500 font-medium mt-2 block">
                      {error}
                    </span>
                  )}

                  {socialLoginError?.length > 0 && (
                    <span className="text-xs sm:text-sm font-urbanist text-red-500 font-medium mt-2 block">
                      {socialLoginError}
                    </span>
                  )}

                  <p className="font-urbanist font-normal text-xs text-gray-400 mt-4 block text-center">
                    Already have an account?{" "}
                    <span
                      className="text-purple15 dark:text-blue-500 cursor-pointer"
                      onClick={() =>
                        navigate("/instructor-auth/login", {
                          replace: true,
                        })
                      }
                    >
                      Login
                    </span>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AccountVerificationPopup
        showPopup={accountVerificationPendingModal}
        handleCloseAccountVerificationModal={
          handleCloseAccountVerificationModal
        }
        message={
          "Your account is in review with us, Once approved you will receive an email from us."
        }
        title={"Account Status Pending"}
      />
    </GoogleOAuthProvider>
  );
};

export default InstructorSignup;
